import { ReactElement, ReactNode } from 'react';
import { cn } from '@anytag/shared-utils';
import { Delayed } from '../Delayed';
import { ListEmpty } from '../ListEmpty';
import { Loading, LoadingProps } from '../Loading';

export interface RenderDataWithFallbackProps {
  loading?: boolean;
  hasNoData?: boolean;
  children?: ReactNode;
  awaitedTime?: number;
  skipDelayed?: boolean;
  noDataNode?: ReactElement | null;
  loadingNode?: ReactElement;
  loadingProps?: LoadingProps;
}

export const RenderDataWithFallback = ({
  loading,
  children,
  hasNoData,
  awaitedTime,
  skipDelayed,
  loadingProps,
  loadingNode = (
    <Delayed asChild={skipDelayed} awaitedTime={awaitedTime}>
      <Loading {...loadingProps} className={cn('bg-white', loadingProps?.className)} />
    </Delayed>
  ),
  noDataNode = <ListEmpty />
}: RenderDataWithFallbackProps) => <>{loading ? loadingNode : hasNoData ? noDataNode : children}</>;
